// ============================================================================
// ecgRenderer.tsx — ПРИЛОЖЕНИЕ «ЭКГ» (appKind/code 'ecg'): точка входа
// в оболочке «Предприятие» (док/«Пуск»). Рендерер регистрируется КЛИЕНТОМ,
// приложение в доке — по составу воркспейса с сервера (поставка модуля).
// Доступ — роли «Врач» (ядро «ГидраМедик»), «Студент»/«Преподаватель»
// (роли модуля, имена из JWT); без роли приложение не показывается
// (useVisibleApps), прямой адрес — пустой экран.
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { EcgAnalysisPage, ECG_APP_CODE } from '@/pages/EcgAnalysisPage';
import { useSecurityAccess } from '@/lib/securityRoles';
import { canUseEcg } from '@/lib/ecgRoles';

function EcgApp() {
    const access = useSecurityAccess();
    const allowed = canUseEcg(access);
    // Недоступное приложение НЕ показываем и НЕ объясняем пользователю технические
    // роли: в доке его нет (фильтр useVisibleApps), прямой адрес — пустой экран.
    if (!allowed) return null;
    return <EcgAnalysisPage />;
}

/** Манифест приложения (AppHost): разбор ЭКГ, на весь воркспейс. */
export const ECG_MANIFEST: AppManifest = {
    code: ECG_APP_CODE,
    name: ECG_APP_CODE,
    synonym: 'ЭКГ',
    appKind: ECG_APP_CODE,
    area: 'full',
    apiVersion: APPSDK_VERSION,
    permissions: [],
};

export function registerEcgApp(): void {
    registerAppRenderer({
        appKind: ECG_APP_CODE,
        code: ECG_APP_CODE,
        title: 'ЭКГ',
        Component: EcgApp,
        manifest: ECG_MANIFEST,
    });
}
